export default "__VITE_ASSET__hkkOkJON__"